import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CsIconModule } from '@components/icon';
import { HairDandruffRegimenBannerComponentComponent } from './hair-dandruff-regimen.component';

@NgModule({
  declarations: [HairDandruffRegimenBannerComponentComponent],
  imports: [
    CommonModule,
    CsIconModule,
  ],
  exports: [HairDandruffRegimenBannerComponentComponent],
})

export class HairDandruffBannerRegimenModule { }
